export type ResellerData = { resellerId?: string; additionalResellerData?: string };

export function setResellerData(resellerId: string, additionalResellerData?: string): void;
export function setResellerData(options: ResellerData): void;
export function setResellerData(resellerIdOrOptions: string | ResellerData, additionalResellerData?: string): void {
    if (typeof resellerIdOrOptions !== 'string') {
        additionalResellerData = resellerIdOrOptions.additionalResellerData;
        resellerIdOrOptions = resellerIdOrOptions.resellerId;
    }
    if (resellerIdOrOptions) {
        sessionStorage.setItem('r', resellerIdOrOptions);
    }
    if (additionalResellerData) {
        sessionStorage.setItem('ard', additionalResellerData);
    }
}

export function getResellerData(): ResellerData {
    const resellerId = sessionStorage.getItem('r') ?? undefined;
    const additionalResellerData = sessionStorage.getItem('ard') ?? undefined;

    return { resellerId, additionalResellerData };
}
